export default {
    Metadata: {
        Name: "Asin",
        Description: "Returns the arcsine (in radians) of a number.",
        Syntax: "Asin(number)",
        Keywords: ['Math', 'Trig', 'Angle'],
        Author: "DataVoke, Inc.",
    },
    execute(v) {
        return Math.asin(v);
    },
};

